import React, {useEffect, useRef, useState} from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
    Box,
    Button,
    styled,
    TableCell,
    TableContainer,
    TableSortLabel,
    Tooltip,
    tooltipClasses,
    Typography
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import HispsEditDialog from "./HispsEditDialog";
import HispsDeleteDialog from "./HispsDeleteDialog";
import {useCookies} from "react-cookie";
import {ApiUrl} from "../utils/portal-urls";

const StyledTableRow = styled(TableRow)(({theme}) => ({
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
})
const StyledCertificateDiv = styled('div')({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
})
const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.primary.main,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.primary.main,
        fontSize: '14px'
    },
}));

export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    } else if (b[orderBy] > a[orderBy]) {
        return 1;
    } else {
        return 0;
    }
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

export const sortedRowInformation = (rowArray, comparator) => {
    const stabilizedRowArray = rowArray.map((element, index) => [element, index])
    stabilizedRowArray.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    })
    return stabilizedRowArray.map((element) => element[0]);
}

export default function HispsAsList(props) {
    const hisps = props.hispsResult || [];
    const setRefresh = props.setRefresh;
    const refresh = props.refresh;

    const [editHispDialogOpen, setEditHispDialogOpen] = useState(false);
    const [hisp, setHisp] = useState({});
    const [deleteHispDialogOpen, setDeleteHispDialogOpen] = useState(false);

    const [orderDirection, setOrderDirection] = useState('asc');
    const [valueToOrderBy, setValueToOrderBy] = useState('hispId');
    const [hispList, setHispList] = useState([]);

    const [hispEndpoints, setHispEndpoints] = useState([]);
    const [fhirConfig, setFhirConfig] = useState([]);

    // cookie to save hisp order state
    const [cookie, setCookie] = useCookies(['sorted_dir', 'sorted_name'])

    // useEffect(() => {
    //     const url = ApiUrl.Hisps.fhirConfig.getPath;
    //     console.log("get: " + url);
    //     fetch(url)
    //         .then(response => response.json())
    //         .then(data => setFhirConfig(data))
    //         .catch(error => console.error(error));
    //     console.log("fhirConfig: " + fhirConfig);
    // }, []);

    useEffect(() => {
        if (cookie.sorted_dir) {
            setHispList(() => sortedRowInformation(hisps, getComparator(cookie.sorted_dir, valueToOrderBy)));
            setOrderDirection(cookie.sorted_dir);
        } else {
            setHispList(() => sortedRowInformation(hisps, getComparator(orderDirection, valueToOrderBy)));
        }
    }, [orderDirection, valueToOrderBy, hisps])

    // useEffect(() => {
    //     async function fetchData() {
    //         const data = await Promise.all(
    //             hispList.map(async (hisp) => {
    //                 const response = await fetch(`${fhirConfig.fhirEndpoint}/Endpoint?${fhirConfig.hipsSearchParameter}=${hisp.hispId}&_count=0`);
    //                 const values = await response.json();
    //                 return { ...hisp, values };
    //             })
    //         );
    //
    //         setHispEndpoints(data);
    //         console.log("hispEndpoints: " + hispEndpoints)
    //     }
    //     fetchData();
    // }, [hispList, fhirConfig]);

    const handleCookie = (dir) => {
        let expires = new Date();
        expires.setMonth(expires.getMonth() + 1);
        setCookie('sorted_dir', dir, { path: '/', expires})
    }

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    }

    const handleRequestSort = (event, property) => {
        const isAscending = (valueToOrderBy === property && orderDirection === 'asc');
        const direction = isAscending ? 'desc' : 'asc'
        setValueToOrderBy(property);
        setOrderDirection(direction);
        handleCookie(direction);
    }

    const handleEditHispClick = (hisp) => {
        setHisp(hisp)
        setEditHispDialogOpen(true);
    }

    const handleDeleteHispClick = (hisp) => {
        setHisp(hisp)
        setDeleteHispDialogOpen(true);
    }

    const handleDirection = () => {
        if (valueToOrderBy === 'hispId') {
            return cookie.sorted_dir ?? orderDirection;
        } else {
            return cookie.sorted_dir ?? 'asc';
        }
        // return valueToOrderBy === 'hispId' ? orderDirection : 'asc'
    }


    return (
        <TableContainer sx={{mt: '10px'}}>
            {hisp?.status && hisps &&
                <HispsEditDialog
                    hisps={hisps}
                    status={hisp.status}
                    setRefresh={(c) => setRefresh(c)}
                    hisp={hisp}
                    setHisp={(c) => setHisp(c)}
                    setEditHispDialogOpen={(c) => setEditHispDialogOpen(c)}
                    editHispDialogOpen={editHispDialogOpen}
                    refresh={refresh}
                />
            }
            {hisp &&
                <HispsDeleteDialog
                    setRefresh={(c) => setRefresh(c)}
                    hisp={hisp}
                    setDeleteHispDialogOpen={(c) => setDeleteHispDialogOpen(c)}
                    deleteHispDialogOpen={deleteHispDialogOpen}
                />
            }

            <Table sx={{m: 0}}>
                <TableHead>
                    <TableRow >
                        <StyledTableCell>

                        </StyledTableCell>
                        <StyledTableCell>
                            <TableSortLabel
                                active={valueToOrderBy === 'hispId'}
                                direction={handleDirection()}
                                onClick={createSortHandler('hispId')}
                            >
                                HISP
                            </TableSortLabel>
                        </StyledTableCell>
                        <StyledTableCell>Certificate</StyledTableCell>
                        <StyledTableCell>Technical Contact</StyledTableCell>
                        <StyledTableCell>Directory Steward</StyledTableCell>
                        <StyledTableCell>Status</StyledTableCell>
                        <StyledTableCell>Comment</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/*{hisps && hisps.map(h => (*/}
                    {/*{hisps && sortedRowInformation(hisps, getComparator(orderDirection, valueToOrderBy)).map(h => (*/}
                    {hisps && hispList && hispList.map(h => (
                        <StyledTableRow key={h.hispId}>
                            <TableCell>
                                {h.logoUrl &&
                                    <img src={h.logoUrl}
                                         alt={h.hispName}
                                         style={{ maxWidth: 75, maxHeight: 75}}
                                    />
                                }
                            </TableCell>
                            <TableCell>
                                <div>
                                    <div style={{fontWeight: 'bold'}}>{h.hispId}</div>
                                    <div>{h.hispName}</div>
                                    <div style={{ color: '#777777'}}>Version: {h.formatVersion}</div>
                                    {/*{h.logoUrl &&*/}
                                    {/*    <img src={h.logoUrl}*/}
                                    {/*         alt={h.hispName}*/}
                                    {/*         style={{ maxWidth: 75, maxHeight: 75}}*/}
                                    {/*    />*/}
                                    {/*}*/}
                                </div>
                            </TableCell>
                            <TableCell style={{ maxWidth: '350px' }}>
                                {h.certThumb && <StyledCertificateDiv>SHA2: {h.certThumb}</StyledCertificateDiv>}
                                {/*<div >{h.certThumb && `SHA2: ${h.certThumb}`}</div>*/}
                                <div>{h.certSubject && `Subject: ${h.certSubject}`}</div>
                            </TableCell>
                            <TableCell>
                                <div >{h.contactName && `Name: ${h.contactName}`}</div>
                                <div >{h.contactPhone && `Phone: ${h.contactPhone}`}</div>
                                <div >{h.contactEmail && `Email: ${h.contactEmail}`}</div>
                            </TableCell>
                            <TableCell>
                                <div >{h.stewardContactName && `Name: ${h.stewardContactName}`}</div>
                                <div >{h.stewardContactPhone && `Phone: ${h.stewardContactPhone}`}</div>
                                <div >{h.stewardContactEmail && `Email: ${h.stewardContactEmail}`}</div>
                            </TableCell>
                            <TableCell>
                                <div >{h.status && `Status: ${h.status}`}</div>
                                {/*<div >{h.admin && `(ADMIN)`}</div>*/}
                            </TableCell>
                            <TableCell>{h.comment}</TableCell>
                            <TableCell>
                                <Box sx={{ display: 'flex', gap: '5px'}}>
                                    <Button variant='contained' size='small' onClick={() => handleEditHispClick(h)}>Edit</Button>
                                    <Button variant='contained' color='error' size='small' onClick={() => handleDeleteHispClick(h)}>Delete</Button>
                                </Box>
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
